const JobsheetImages = ({job_sheet_images}) => {
    return(
        <div className="pt-4 p-2">
            {job_sheet_images && job_sheet_images.length > 0 ? (
                <div className="scroll-container">
                    {job_sheet_images?.map((image, imageIndex) => (
                        <a href={image.job_sheet_image_path} target="_blank" rel="noreferrer" key={imageIndex}>
                            <img src={image.job_sheet_image_path} alt="Cinque Terre" lassName="mb-1"/>
                        </a>
                    ))}
                </div>
            ) : (
                <span className="text-md">Sorry, no data found!</span>
            )}
        </div>
    );
}

export default JobsheetImages